export default "__VITE_ASSET__BGzli6zR__"